import React from 'react'
import { useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import type { MultiSelect as MultiSelectProps } from '@flows/core/types/stepContentTypes'
import type { FlowValues } from '@flows/core/types/stepTypes'
import UiKitMultiSelect from '@ui-kit/components/formComponents/MultiSelect'

export const MultiSelect = <TProps extends MultiSelectProps<any, any>>(
  props: TProps & { flowValues: FlowValues }
) => {
  const { t } = useTranslation()
  const { field, fieldState } = useController({
    name: props.name,
  })
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, {
    flowValues: props.flowValues,
    servicesResponses,
  })

  const translatedOptions = props.options.map((option) => {
    return {
      label: translateFunction(option.label),
      value: option.value,
    }
  })

  return (
    <UiKitMultiSelect
      value={field.value}
      options={translatedOptions}
      onValueChange={field.onChange}
      errorMessage={fieldState.error?.message}
    />
  )
}
